import { useCallback } from 'react';
import { useEvaluationStore } from '../store';

export const useCompetencyHandlers = (
  isReviewerViewingOwn: boolean,
  reviewerId: string,
  revieweeId: string
) => {
  const { setSelectedScale, setComponentAnswer, responsesByComponentId } = useEvaluationStore();

  const handleScaleSelect = useCallback((
    role: 'reviewee' | 'reviewer',
    competencyId: string,
    scaleId: string
  ) => {
    setSelectedScale(role, competencyId, scaleId);

    const currentUserId = role === 'reviewer' ? reviewerId : revieweeId;
    const entry = responsesByComponentId?.[String(competencyId)];
    const raw = currentUserId ? entry?.answersByUserId?.[currentUserId] : undefined;
    const existingAnswerObj: any = raw && typeof raw === 'object'
      ? (raw as any).answer || raw
      : undefined;
    const existingComment = existingAnswerObj?.comment || '';

    setComponentAnswer(String(competencyId), currentUserId, {
      answer: {
        scale_id: scaleId,
        comment: existingComment,
      },
    });
  }, [setSelectedScale, setComponentAnswer, reviewerId, revieweeId, responsesByComponentId]);

  const handleSaveComment = useCallback((
    competencyId: string,
    commentValue: string
  ) => {
    const currentUserId = isReviewerViewingOwn ? reviewerId : revieweeId;
    if (competencyId && currentUserId) {
      const existingRaw = responsesByComponentId?.[String(competencyId)]?.answersByUserId?.[currentUserId];
      const existingObj: any = existingRaw && typeof existingRaw === 'object'
        ? (existingRaw as any).answer || existingRaw
        : undefined;
      const existingScaleId = existingObj?.scale_id || existingObj?.scaleId;

      setComponentAnswer(String(competencyId), currentUserId, {
        answer: {
          comment: commentValue,
          ...(existingScaleId ? { scale_id: existingScaleId } : {}),
        },
      });
    }
  }, [isReviewerViewingOwn, reviewerId, revieweeId, responsesByComponentId, setComponentAnswer]);

  return {
    handleScaleSelect,
    handleSaveComment,
  };
};
